import { isProd } from '../../utils/env';
export const ESSENTIAL_APPS_FOR_DATA_ACTIVATION = isProd() ? 652035 : undefined;
export const ESSENTIAL_APPS_FOR_SALES = isProd() ? 556033 : undefined;
export const ESSENTIAL_APPS_FOR_MARKETERS = isProd() ? 556028 : undefined;
export const APPS_FOR_BREEZE_STUDIO = isProd() ? 652038 : undefined;
export const APPS_FOR_BREEZE_ASSISTANT = isProd() ? 645033 : undefined;
export const APPS_FOR_BREEZE_AGENTS_MCP = isProd() ? 682033 : undefined;
export const APPS_WITH_APP_PAGES = isProd() ? 685033 : undefined;
export const LLM_CUSTOM_WORKFLOW_ACTIONS = isProd() ? 652037 : undefined;
export const SUGGESTED_COLLECTION_IDS = [APPS_WITH_APP_PAGES, APPS_FOR_BREEZE_AGENTS_MCP].filter(id => id !== undefined);
export const APPS_SUGGESTED_COLLECTION_IDS = [ESSENTIAL_APPS_FOR_MARKETERS, ESSENTIAL_APPS_FOR_SALES].filter(id => id !== undefined);